module.exports = __webpack_public_path__ + "static/gallery-14-3746bb6f4a472188f6375a89313b24ef.jpg";